<template>
	<component :is="dialogTag" v-model="isOpen" :fullscreen="props.fullscreen" :transition="dialogTag === 'v-bottom-sheet' ? undefined : props.transition" class="dialog-control__overlay">
		<template v-if="$slots.activator" #activator="slotProps">
			<slot name="activator" v-bind="slotProps" />
		</template>
		<slot />
	</component>
</template>

<script setup>
import { computed, inject, ref, onMounted, onUnmounted } from 'vue';
import { deviceUtils } from '@/utils/core/deviceUtils';
import { useOverlayScrimClose } from '@/composables/useOverlayScrimClose';

const props = defineProps({
	modelValue: { type: Boolean, default: false },
	fullscreen: { type: Boolean, default: false },
	mobile: { type: Boolean, default: null },
	transition: { type: [String, Boolean, Object], default: undefined },
});
const emit = defineEmits(['update:modelValue']);

const overlayTarget = inject('overlayTarget', null);

const isOpen = computed({
	get: () => props.modelValue,
	set: (value) => emit('update:modelValue', value),
});

const isTablet = ref(deviceUtils.isTablet());
function onResize() {
	isTablet.value = deviceUtils.isTablet();
}
onMounted(() => window.addEventListener('resize', onResize));
onUnmounted(() => window.removeEventListener('resize', onResize));

const isMobile = computed(() => (props.mobile !== null ? props.mobile : isTablet.value));
const dialogTag = computed(() => (isMobile.value && !props.fullscreen ? 'v-bottom-sheet' : 'v-dialog'));

useOverlayScrimClose(
	isOpen,
	() => {
		isOpen.value = false;
	},
	overlayTarget,
	'.dialog-control__overlay'
);
</script>
